/* PTB Atelier — données : catalogue Shopify (Storefront API), variantes, couleurs, estimation panier / livraison.
   Aucune donnée inventée : tout vient de la boutique (collection « articles personnalisables », variantes, prix, disponibilité, tarifs de livraison).

   Modèle : chaque article personnalisable est un produit « jumeau » (étiquette atelier_ref:<produit de référence>) dont les variantes
   portent EXACTEMENT les prix du site et n'entrent dans aucune remise de pack. Les noms de couleurs traduits et la disponibilité
   viennent du produit de référence : une variante n'est proposée que si le jumeau ET la référence sont disponibles. Les photos sont celles du
   jumeau quand il en a (articles vierges, sans broderie), sinon celles du produit de référence (vue de dos vierge). */
(function () {
  'use strict';
  var C = window.PTB_ATELIER_CFG;
  if (!C) return;
  var A = (window.PTBAtelier = window.PTBAtelier || {});

  var GQL_LANG = { fr: 'FR', en: 'EN', ar: 'AR' }[C.lang] || 'FR';
  var COUNTRY = /^[A-Z]{2}$/.test(C.country || '') ? C.country : 'FR';
  var HANDLE_RE = /^[a-z0-9][a-z0-9-]{0,254}$/;

  function ctx(country, lang) { return '@inContext(country: ' + country + ', language: ' + lang + ')'; }

  function gql(query, variables) {
    return fetch(C.apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (j) {
      if (j.errors && (!j.data || !Object.keys(j.data).length)) throw new Error((j.errors[0] && j.errors[0].message) || 'GraphQL');
      return j;
    });
  }

  function num(v) { var n = parseFloat(v); return isFinite(n) ? n : 0; }
  function gidNum(gid) { return String(gid || '').split('/').pop().split('?')[0]; }
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9؀-ۿ]+/g, ' ').trim();
  }

  /* ---------- argent ---------- */
  var moneyLocale = C.lang === 'en' ? 'en-GB' : 'fr-FR';
  function money(amount, currency) {
    try {
      return new Intl.NumberFormat(moneyLocale, { style: 'currency', currency: currency || C.currency || 'EUR' }).format(amount);
    } catch (e) {
      return (Math.round(amount * 100) / 100).toFixed(2) + ' ' + (currency || '');
    }
  }

  /* ---------- classes d'articles (étiquette atelier_class:<classe>) -> catégorie d'affichage + silhouette d'aperçu ---------- */
  var CLASSES = {
    tee: { cat: 'tshirt', sub: 'top' }, ovr: { cat: 'tshirt', sub: 'top' }, polo: { cat: 'polo', sub: 'top' },
    hood: { cat: 'sweat', sub: 'top' }, crop: { cat: 'sweat', sub: 'top' },
    cap: { cat: 'headwear', sub: 'cap' }, bean: { cat: 'headwear', sub: 'beanie' }, bag: { cat: 'bag', sub: 'bag' },
    baby: { cat: 'baby', sub: 'top' }
  };
  function tagValue(tags, prefix) {
    for (var i = 0; i < (tags || []).length; i++) if (tags[i].indexOf(prefix) === 0) return tags[i].slice(prefix.length);
    return '';
  }
  /* repli si un article n'a pas d'étiquette de classe : d'après le titre français */
  function categorize(p) {
    var cls = tagValue(p.tags, 'atelier_class:');
    if (CLASSES[cls]) return { cls: cls, cat: CLASSES[cls].cat, sub: CLASSES[cls].sub };
    var t = norm(p.titleFr || p.title) + ' ' + p.handle.replace(/-/g, ' ');
    function has(re) { return re.test(t); }
    if (has(/\bcasquette|\bsnapback|\bcap\b/)) return { cls: 'cap', cat: 'headwear', sub: 'cap' };
    if (has(/\bbonnet|\bbeanie/)) return { cls: 'bean', cat: 'headwear', sub: 'beanie' };
    if (has(/\bbody\b|\bbebe|\bbaby|\bbodysuit/)) return { cls: 'baby', cat: 'baby', sub: 'top' };
    if (has(/\bsac\b|\btote\b|\bsacoche|\bbag\b/)) return { cls: 'bag', cat: 'bag', sub: 'bag' };
    if (has(/\bpolo/)) return { cls: 'polo', cat: 'polo', sub: 'top' };
    if (has(/\bsweat|\bhoodie|\bcapuche/)) return { cls: 'hood', cat: 'sweat', sub: 'top' };
    if (has(/\bt shirt|\btee\b|\btshirt|\boversize/)) return { cls: 'tee', cat: 'tshirt', sub: 'top' };
    return { cls: 'other', cat: 'other', sub: 'other' };
  }
  /* « T-shirt classique — Atelier » -> « T-shirt classique » (le suffixe sert à distinguer l'article dans le panier et la commande) */
  function cleanTitle(t) { return String(t || '').replace(/\s*[—–-]\s*(Atelier|Workshop|الورشة)\s*$/i, '').trim(); }

  /* photo de carte : même logique que les cartes du thème (plutôt blanc, jamais noir par défaut) */
  function pickImage(images, featured) {
    var white = null, fallback = null;
    (images || []).forEach(function (im) {
      var key = ((im.url || '') + ' ' + (im.altText || '')).toLowerCase();
      if (!white && (key.indexOf('white') >= 0 || key.indexOf('blanc') >= 0)) white = im;
      if (!fallback && key.indexOf('black') < 0) fallback = im;
    });
    return (white || fallback || featured || (images && images[0]) || null);
  }

  /* Les photos du site montrent l'article avec sa broderie. Pour personnaliser, on préfère la vue de DOS du même coloris (vierge) quand
     elle existe : c'est un article « prêt à broder ». Casquettes, bonnets et sacs n'ont qu'une vue : on garde alors la photo de face. */
  function fileKey(url) { return String(url || '').split('?')[0].split('/').pop(); }
  function isBack(im) { return /-back-[0-9a-f]+\.[a-z]+$/i.test(fileKey(im.url)); }
  function blankOf(images, url) {
    var m = fileKey(url).match(/^(.*)-(front|left-front|left|right|right-side|back)-[0-9a-f]+\.[a-z]+$/i);
    if (!m) return null;
    var prefix = m[1] + '-back-';
    for (var i = 0; i < (images || []).length; i++) if (fileKey(images[i].url).indexOf(prefix) === 0) return images[i];
    return null;
  }
  function cardImage(ref, fallback) {
    var imgs = (ref && ref.images && ref.images.nodes) || [];
    var backs = imgs.filter(isBack);
    return pickImage(backs.length ? backs : imgs, (ref && ref.featuredImage) || fallback);
  }

  A.data = {};

  /* ---------- catalogue ---------- */
  var COLL_Q = 'query Coll($h:String!) ' + ctx(COUNTRY, GQL_LANG) +
    ' { collection(handle:$h) { products(first:50) { nodes { id handle title tags productType availableForSale' +
    ' featuredImage { url altText } priceRange { minVariantPrice { amount currencyCode } } } } } }';
  var COLL_FR_Q = 'query CollFr($h:String!) ' + ctx(COUNTRY, 'FR') + ' { collection(handle:$h) { products(first:50) { nodes { id title } } } }';

  function refsQuery(handles) {
    var body = handles.map(function (h, i) {
      return 'r' + i + ': product(handle: "' + h + '") { handle availableForSale featuredImage { url altText } images(first: 50) { nodes { url altText } } }';
    }).join(' ');
    return 'query Refs ' + ctx(COUNTRY, GQL_LANG) + ' { ' + body + ' }';
  }

  A.data.fetchCatalog = function () {
    var h = C.collection || 'atelier-articles';
    var frReq = GQL_LANG === 'FR' ? Promise.resolve(null) : gql(COLL_FR_Q, { h: h }).then(function (j) { return j.data.collection; }).catch(function () { return null; });
    return Promise.all([gql(COLL_Q, { h: h }), frReq]).then(function (res) {
      var coll = res[0].data.collection;
      if (!coll) throw new Error('collection');
      var frTitles = {};
      ((res[1] && res[1].products.nodes) || []).forEach(function (p) { frTitles[p.id] = p.title; });
      /* seuls les articles « de base » (étiquette atelier_base : jumeaux sans remise de pack, non synchronisés avec l'imprimeur) sont proposés ;
         un produit du site ajouté tel quel à la collection n'est jamais commandable depuis l'Atelier (il partirait en fabrication avec sa broderie d'origine). */
      var twins = coll.products.nodes.filter(function (p) {
        var type = (p.productType || '').toLowerCase();
        return p.availableForSale && p.handle !== C.markerHandle && type !== 'gift card' && (p.tags || []).indexOf('atelier_base') >= 0;
      });
      var refHandles = [];
      twins.forEach(function (p) {
        var r = tagValue(p.tags, 'atelier_ref:');
        p.refHandle = HANDLE_RE.test(r) ? r : '';
        if (p.refHandle && refHandles.indexOf(p.refHandle) < 0) refHandles.push(p.refHandle);
      });
      var refReq = refHandles.length ? gql(refsQuery(refHandles)).then(function (j) { return j.data; }) : Promise.resolve({});
      return refReq.then(function (refData) {
        var refs = {};
        refHandles.forEach(function (rh, i) { var r = refData['r' + i]; if (r) refs[rh] = r; });
        var out = [];
        twins.forEach(function (p) {
          var ref = p.refHandle ? refs[p.refHandle] : null;
          /* un jumeau dont la référence a disparu ou n'est plus en vente ne peut pas être fabriqué : on ne le propose pas */
          if (p.refHandle && !ref) return;
          if (ref && ref.availableForSale === false) return;
          /* photo vierge propre au jumeau (sans broderie) en priorité ; à défaut, photo de l'article du site (vue de dos vierge si elle existe) */
          var img = p.featuredImage || (ref ? cardImage(ref, null) : null);
          var m = {
            id: gidNum(p.id), gid: p.id, handle: p.handle, refHandle: p.refHandle, title: cleanTitle(p.title), fullTitle: p.title,
            titleFr: cleanTitle(frTitles[p.id] || p.title), tags: p.tags || [],
            image: img ? img.url : null, imageAlt: (img && !p.featuredImage) ? (img.altText || '') : '',   /* photos du jumeau : texte alternatif = titre traduit (la légende du média est en français) */
            price: num(p.priceRange.minVariantPrice.amount), currency: p.priceRange.minVariantPrice.currencyCode
          };
          var c = categorize(m);
          m.cls = c.cls; m.cat = c.cat; m.sub = c.sub;
          out.push(m);
        });
        return out;
      });
    });
  };

  /* ---------- couleurs : pastilles du thème (window.PBColor) avec repli local ---------- */
  var COLOR_WORDS = [
    [/noir|black/, '#111111'], [/blanc|white/, '#ffffff'], [/rouge|red|bordeaux|maroon/, '#a8242f'], [/rose|pink/, '#e7a9b4'],
    [/bleu|blue|navy|marine|sky/, '#2f6fd6'], [/vert|green|olive|kaki|khaki/, '#4f7a4f'], [/jaune|yellow|gold|or\b/, '#e0b43a'],
    [/orange/, '#ef7b2d'], [/violet|purple|lavand/, '#8a6bb8'], [/gris|grey|gray|charcoal|ash/, '#8f8f8f'], [/marron|brown/, '#6b4423'],
    [/beige|sable|sand|stone|pierre|natural|naturel|bone|cream|creme/, '#d8cdb4']
  ];
  var colorCache = {};
  A.data.colorHex = function (frValue) {
    var key = String(frValue || '');
    if (colorCache[key]) return colorCache[key];
    var hex = null;
    try { if (window.PBColor && window.PBColor.hex) hex = window.PBColor.hex(key); } catch (e) { hex = null; }
    if (!hex) {
      var n = norm(key);
      for (var i = 0; i < COLOR_WORDS.length; i++) if (COLOR_WORDS[i][0].test(n)) { hex = COLOR_WORDS[i][1]; break; }
    }
    colorCache[key] = hex || '#8a8a8a';
    return colorCache[key];
  };

  /* ---------- article détaillé : jumeau + référence ---------- */
  var T_FIELDS = 'id handle title tags options { name values } variants(first:100) { nodes { id title sku availableForSale price { amount currencyCode } compareAtPrice { amount } selectedOptions { name value } image { url altText } } }';
  var R_FIELDS = 'id handle title availableForSale images(first:50) { nodes { url altText } } variants(first:100) { nodes { id availableForSale selectedOptions { name value } image { url altText } } }';
  var T_FR_FIELDS = 'title options { name } variants(first:100) { nodes { id selectedOptions { name value } } }';
  var R_FR_FIELDS = 'variants(first:100) { nodes { id availableForSale selectedOptions { name value } } }';
  function detailQuery(lang, tf, rf) { return 'query D($t:String!,$r:String!) ' + ctx(COUNTRY, lang) + ' { t: product(handle:$t) { ' + tf + ' } r: product(handle:$r) { ' + rf + ' } }'; }

  function roleOf(name) {
    var n = norm(name);
    if (/colou?r|couleur/.test(n) || /لون/.test(name)) return 'color';
    if (/\bsize\b|taille/.test(n) || /مقاس|حجم/.test(name)) return 'size';
    if (n === 'title' || n === 'titre') return 'title';
    return 'other';
  }
  function keyOf(selected) { return selected.map(function (o) { return norm(o.value); }).join('|'); }

  A.data.fetchProduct = function (handle, meta) {
    meta = meta || {};
    var refHandle = meta.refHandle && HANDLE_RE.test(meta.refHandle) ? meta.refHandle : handle;
    var vars = { t: handle, r: refHandle };
    var cur = gql(detailQuery(GQL_LANG, T_FIELDS, R_FIELDS), vars);
    var fr = GQL_LANG === 'FR' ? cur : gql(detailQuery('FR', T_FR_FIELDS, R_FR_FIELDS), vars).catch(function () { return null; });
    return Promise.all([cur, fr]).then(function (res) {
      var t = res[0].data.t, r = res[0].data.r;
      if (!t) throw new Error('not-found');
      var frT = (res[1] && res[1].data && res[1].data.t) || t;
      var frR = (res[1] && res[1].data && res[1].data.r) || r;

      var frTwin = {};
      (frT.variants.nodes || []).forEach(function (v) { frTwin[v.id] = v.selectedOptions.map(function (o) { return o.value; }); });
      /* variantes de la référence, indexées par valeurs d'options françaises (couleur|taille) */
      var refCur = {}, refAvail = {}, refFrById = {};
      ((frR && frR.variants.nodes) || []).forEach(function (v) { refFrById[v.id] = v; refAvail[keyOf(v.selectedOptions)] = { id: v.id, available: v.availableForSale !== false }; });
      ((r && r.variants.nodes) || []).forEach(function (v) {
        var f = refFrById[v.id];
        var k = keyOf((f || v).selectedOptions);
        refCur[k] = { id: v.id, labels: v.selectedOptions.map(function (o) { return o.value; }), image: v.image ? { url: v.image.url, alt: v.image.altText || '' } : null };
      });
      var hasRef = !!r;
      var refImages = (r && r.images && r.images.nodes) || [];

      var options = t.options.map(function (o, i) {
        var frName = (frT.options && frT.options[i]) ? frT.options[i].name : o.name;
        return { name: o.name, role: roleOf(frName) === 'other' ? roleOf(o.name) : roleOf(frName), values: o.values };
      });
      var variants = t.variants.nodes.map(function (v) {
        var vals = v.selectedOptions.map(function (o) { return o.value; });
        var valsFr = frTwin[v.id] || vals;
        var k = valsFr.map(norm).join('|');
        var rc = refCur[k], ra = refAvail[k];
        var available = !!v.availableForSale && (!hasRef || (!!ra && ra.available));
        var own = v.image ? { url: v.image.url, alt: v.image.altText || '' } : null;   /* photo vierge du jumeau : déjà sans broderie */
        var base = own || (rc && rc.image) || null;
        var blank = (!own && base) ? blankOf(refImages, base.url) : null;
        var img = blank ? { url: blank.url, alt: blank.altText || '' } : base;
        return {
          id: gidNum(v.id), gid: v.id, refId: rc ? gidNum(rc.id) : '', title: v.title, sku: v.sku || '', available: available,
          price: num(v.price.amount), currency: v.price.currencyCode, compareAt: v.compareAtPrice ? num(v.compareAtPrice.amount) : 0,
          options: vals, optionsFr: valsFr, labels: (rc && rc.labels && rc.labels.length === vals.length) ? rc.labels : vals,
          image: img
        };
      });
      var d = {
        id: gidNum(t.id), gid: t.id, handle: t.handle, refHandle: refHandle, title: cleanTitle(t.title), fullTitle: t.title, tags: t.tags || [],
        options: options, variants: variants, colorIdx: -1, sizeIdx: -1
      };
      options.forEach(function (o, i) {
        if (o.role === 'color' && d.colorIdx < 0) d.colorIdx = i;
        if (o.role === 'size' && d.sizeIdx < 0) d.sizeIdx = i;
      });
      /* valeurs distinctes (ordre boutique) : valeur du jumeau (clé stable), libellé affiché, valeur française (pastille, e-mails) */
      function distinct(idx, withImage) {
        var seen = {}, out = [];
        variants.forEach(function (v) {
          var val = v.options[idx];
          if (val === undefined || seen[val]) return;
          seen[val] = 1;
          var item = { value: val, label: v.labels[idx] || val, fr: v.optionsFr[idx] || val };
          if (withImage) item.image = v.image;
          out.push(item);
        });
        return out;
      }
      d.colors = d.colorIdx >= 0 ? distinct(d.colorIdx, true).map(function (c) { c.hex = A.data.colorHex(c.fr); return c; }) : [];
      d.sizes = d.sizeIdx >= 0 ? distinct(d.sizeIdx, false) : [];
      return d;
    });
  };

  /* ---------- estimation exacte : panier Storefront (hors panier du visiteur) ---------- */
  var ZIP = { FR: '75001', DE: '10115', BE: '1000', ES: '28001', IT: '00100', NL: '1011AB', PT: '1000-001', GB: 'SW1A 1AA', CH: '8001', US: '10001', CA: 'M5V 2T6', DZ: '16000', MA: '20000', TN: '1000', LU: '1009', AT: '1010', IE: 'D01 F5P2', SE: '111 20', DK: '1050', PL: '00-001', GR: '105 63' };
  var CART_Q = 'mutation Est($lines:[CartLineInput!]!,$codes:[String!],$cc:CountryCode!,$addr:MailingAddressInput!) ' + ctx(COUNTRY, GQL_LANG) +
    ' { cartCreate(input:{ lines:$lines, discountCodes:$codes, buyerIdentity:{ countryCode:$cc, deliveryAddressPreferences:[{ deliveryAddress:$addr }] } }) {' +
    ' cart { cost { subtotalAmount { amount currencyCode } totalAmount { amount currencyCode } } discountCodes { code applicable }' +
    ' lines(first:50) { nodes { quantity cost { subtotalAmount { amount } totalAmount { amount } } discountAllocations { __typename discountedAmount { amount } ... on CartAutomaticDiscountAllocation { title } } } }' +
    ' deliveryGroups(first:5) { nodes { deliveryOptions { title estimatedCost { amount currencyCode } } } } }' +
    ' userErrors { message code } } }';

  A.data.estimate = function (items, country) {
    var cc = /^[A-Z]{2}$/.test(country || '') ? country : COUNTRY;
    var lines = items.map(function (it) { return { merchandiseId: it.gid, quantity: it.qty }; });
    if (!lines.length) return Promise.resolve(null);
    return gql(CART_Q, {
      lines: lines, codes: [C.freeShipCode || 'FREESHIP'], cc: cc,
      addr: { address1: '-', city: '-', country: cc, zip: ZIP[cc] || '00000' }
    }).then(function (j) {
      var r = j.data && j.data.cartCreate;
      if (!r || !r.cart || (r.userErrors && r.userErrors.length)) throw new Error((r && r.userErrors && r.userErrors[0] && r.userErrors[0].message) || 'cart');
      var cart = r.cart;
      var currency = cart.cost.subtotalAmount.currencyCode;
      var before = 0, after = 0, titles = {};
      cart.lines.nodes.forEach(function (l) {
        before += num(l.cost.subtotalAmount.amount);
        after += num(l.cost.totalAmount.amount);
        (l.discountAllocations || []).forEach(function (d) { if (d.title) titles[d.title] = 1; });
      });
      var opts = [];
      (cart.deliveryGroups.nodes || []).forEach(function (g) { (g.deliveryOptions || []).forEach(function (o) { opts.push({ title: o.title, cost: num(o.estimatedCost.amount) }); }); });
      opts.sort(function (a, b) { return a.cost - b.cost; });
      var code = (cart.discountCodes || []).filter(function (d) { return d.code && d.code.toUpperCase() === (C.freeShipCode || 'FREESHIP').toUpperCase(); })[0];
      var freeShip = !!(code && code.applicable);
      var rate = opts.length ? opts[0].cost : null;
      var shipping = freeShip ? 0 : rate;
      return {
        currency: currency, before: before, after: after, discount: Math.max(0, before - after), discountTitles: Object.keys(titles),
        freeShip: freeShip, shippingRate: rate, shipping: shipping, shippingTitle: opts.length ? opts[0].title : '',
        total: shipping === null ? null : after + shipping, country: cc
      };
    });
  };

  /* ---------- panier de validation : paiement sécurisé Shopify ----------
     Un panier Storefront dédié (lignes = variantes réelles, propriétés de ligne = personnalisation d'UN article) ; le client le règle
     sur le paiement Shopify. Les prix sont ceux du site, sans remise de pack : aucun supplément n'est ajouté. */
  var CHK_Q = 'mutation Chk($input:CartInput!) ' + ctx(COUNTRY, GQL_LANG) +
    ' { cartCreate(input:$input) { cart { id checkoutUrl lines(first:50) { nodes { id merchandise { ... on ProductVariant { id } } } } }' +
    ' userErrors { field message code } } }';
  var TAG_Q = 'mutation Tag($cartId:ID!,$lines:[CartLineUpdateInput!]!,$attrs:[AttributeInput!]!,$note:String!) ' + ctx(COUNTRY, GQL_LANG) +
    ' { cartLinesUpdate(cartId:$cartId, lines:$lines) { userErrors { message } } cartAttributesUpdate(cartId:$cartId, attributes:$attrs) { userErrors { message } } cartNoteUpdate(cartId:$cartId, note:$note) { userErrors { message } } }';

  /* opts : lines [{gid, qty, attrs:[{key,value}]}], attrs [{key,value}], email, phone, codes [..] */
  A.data.createCheckout = function (opts) {
    function run(withIdentity) {
      var input = {
        lines: opts.lines.map(function (l) { return { merchandiseId: l.gid, quantity: l.qty, attributes: l.attrs }; }),
        attributes: opts.attrs || [],
        buyerIdentity: { countryCode: COUNTRY }
      };
      if (withIdentity && opts.email) input.buyerIdentity.email = opts.email;
      if (withIdentity && opts.phone) input.buyerIdentity.phone = opts.phone;
      if (opts.codes && opts.codes.length) input.discountCodes = opts.codes;
      return gql(CHK_Q, { input: input }).then(function (j) {
        var r = j.data && j.data.cartCreate;
        if (!r) throw new Error('cart');
        if (r.userErrors && r.userErrors.length) {
          var e = new Error(r.userErrors[0].message || 'cart');
          e.identity = r.userErrors.some(function (u) { return (u.field || []).join('.').indexOf('buyerIdentity') >= 0; });
          throw e;
        }
        if (!r.cart || !r.cart.checkoutUrl) throw new Error('cart');
        return {
          cartId: r.cart.id, checkoutUrl: r.cart.checkoutUrl,
          lines: r.cart.lines.nodes.map(function (n) { return { id: n.id, merchandiseId: n.merchandise && n.merchandise.id }; })
        };
      });
    }
    /* un e-mail ou un téléphone refusé par Shopify ne doit pas empêcher le paiement : on réessaie sans préremplissage */
    return run(true).catch(function (e) { if (e && e.identity) return run(false); throw e; });
  };

  /* ajoute la référence de la demande aux propriétés des lignes et à la note de commande */
  A.data.tagCheckout = function (cartId, lines, attrs, note) {
    return gql(TAG_Q, { cartId: cartId, lines: lines, attrs: attrs, note: note || '' }).then(function (j) {
      var d = j.data || {}, bad = [d.cartLinesUpdate, d.cartAttributesUpdate, d.cartNoteUpdate].some(function (x) { return !x || (x.userErrors && x.userErrors.length); });
      if (bad) throw new Error('tag');
      return true;
    });
  };

  /* ---------- produit marqueur : ligne à 0 € ajoutée à chaque demande Atelier ----------
     Ce produit n'existe pas (non synchronisé) chez Printful : une commande qui le contient y arrive en BROUILLON au lieu d'être
     fabriquée automatiquement. Les commandes normales n'en contiennent jamais. Il ne change ni le prix, ni la livraison, ni les remises.
     Résultat : null = fonction désactivée (réglage vide) ; { gid } = prêt ; échec (rejet) = produit introuvable ou indisponible :
     on n'envoie PAS le client au paiement, sinon Printful fabriquerait l'article sans la personnalisation. */
  var MARKER_Q = 'query Marker($h:String!) ' + ctx(COUNTRY, GQL_LANG) +
    ' { product(handle:$h) { id availableForSale variants(first:1) { nodes { id availableForSale } } } }';
  var markerPromise = null;
  A.data.loadMarker = function () {
    if (!C.markerHandle) return Promise.resolve(null);
    if (!markerPromise) {
      markerPromise = gql(MARKER_Q, { h: C.markerHandle }).then(function (j) {
        var p = j.data && j.data.product, v = p && p.variants && p.variants.nodes && p.variants.nodes[0];
        if (!v || !v.availableForSale) throw new Error('marker');
        return { gid: v.id };
      }).catch(function (e) { markerPromise = null; throw e; });
    }
    return markerPromise;
  };

  A.util = A.util || {};
  A.util.money = money;
  A.util.norm = norm;
})();
